var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{class:_vm.layoutClass,attrs:{"items":_vm.items,"divider":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }